// ----------------------------------------------------------------------
// Stripe Connect Translations - Spanish
// ----------------------------------------------------------------------

export const stripeConnectEs = {
  stripe_connect: {
    // Account selector
    select_account: 'Seleccionar cuenta Stripe',
    destination_account: 'Cuenta de destino',
    no_accounts_available: 'No hay cuentas Stripe disponibles para transferencias. Por favor, configure una cuenta Stripe en los ajustes de la organización.',
    personal_account: 'Cuenta personal',
    organization_account: 'Cuenta de organización',
    transfer_destination: 'Destino de la transferencia',
    transfer_helper_text: 'La parte del propietario se transferirá a esta cuenta después del evento',
    select_account_for_transfer: 'Seleccione qué cuenta Stripe debe recibir la parte del propietario',

    // Account status
    status_active: 'Activo',
    status_pending: 'Pendiente',
    status_inactive: 'Inactivo',

    // Alerts and messages
    legal_verification: 'Verificación legal requerida',
    complete_stripe_setup: 'Completar configuración de Stripe',
    complete_setup_short: 'Completar',
    setup_stripe_account: 'Configurar cuenta Stripe',
    setup_short: 'Configurar',
    alert_stripe_incomplete_setup: 'La configuración de su cuenta Stripe está incompleta. Complete la verificación para recibir pagos.',
    alert_stripe_configuration_title: 'Se requiere una cuenta Stripe Connect para recibir pagos por sus eventos.',

    // Multi-account messages
    no_stripe_for_org: 'Sin cuenta Stripe para esta organización',
    no_stripe_for_org_named: 'Sin cuenta Stripe para "{{orgName}}"',
    using_personal_account_disclaimer: 'Usando su cuenta Stripe personal.',
    configure_org_account: 'Configurar cuenta de organización',
    has_stripe_on_other_orgs: 'Tiene cuentas Stripe en otras organizaciones. Configure esta organización para usar una cuenta existente o cree una nueva en los ajustes de la organización.',
    has_legacy_account: 'Tiene una cuenta Stripe personal. Actívela para esta organización o cree una nueva en los ajustes de la organización.',
    configure_in_settings: 'Configurar en ajustes',
    setup_in_org_settings: 'Por favor, configure las cuentas Stripe en los ajustes de la organización',
    personal_account_available: 'Cuenta Stripe personal disponible',
    personal_account_hint: 'Tiene una cuenta Stripe personal que puede ser habilitada para "{{orgName}}". Vaya a los ajustes de la organización para configurar las cuentas de pago.',
    org_setup_incomplete_personal_available: 'Configuración de pago de la organización incompleta',
    org_setup_incomplete_personal_hint: 'La configuración de Stripe para "{{orgName}}" aún no está completa. Su cuenta personal se está usando mientras tanto. Complete la configuración de la organización cuando lo desee.',
    alert_stripe_incomplete_setup_org: 'La configuración de la cuenta Stripe para "{{orgName}}" está incompleta. Complete el proceso de verificación para comenzar a recibir pagos por sus eventos.',
    alert_stripe_configuration_org: 'Para recibir pagos por eventos en "{{orgName}}", necesita configurar una cuenta Stripe Connect. Esto es obligatorio para el cumplimiento legal y el procesamiento seguro de pagos.',

    // Stripe accounts manager
    stripe_accounts: 'Cuentas Stripe',
    stripe_accounts_subtitle: 'Gestionar cuentas Stripe Connect para esta organización',
    add_account: 'Agregar cuenta',
    add_new_account: 'Agregar nueva cuenta',
    sync_account: 'Sincronizar cuenta',
    set_as_primary: 'Establecer como principal',
    deactivate_account: 'Desactivar cuenta',
    edit_account: 'Editar cuenta',
    account_name: 'Nombre de la cuenta',
    account_description: 'Descripción',
    account_name_placeholder: 'ej: Cuenta principal, Cuenta festival',
    account_description_placeholder: 'Descripción opcional para esta cuenta',
    primary_account: 'Cuenta principal',
    primary_account_badge: 'Principal',

    // Account stats
    total_accounts: 'Total de cuentas',
    active_accounts: 'Cuentas activas',
    pending_accounts: 'Cuentas pendientes',
    inactive_accounts: 'Cuentas inactivas',

    // Account details
    account_id: 'ID de cuenta',
    charges_enabled: 'Cobros habilitados',
    payouts_enabled: 'Pagos habilitados',
    details_submitted: 'Detalles enviados',
    country: 'País',
    currency: 'Moneda',
    business_type: 'Tipo de negocio',
    last_synced: 'Última sincronización',
    created_at: 'Creado el',
    created_by: 'Creado por',

    // Actions
    complete_onboarding: 'Completar registro',
    view_dashboard: 'Ver panel de Stripe',
    refresh_status: 'Actualizar estado',

    // Confirmations
    confirm_deactivate: '¿Está seguro de que desea desactivar esta cuenta?',
    confirm_deactivate_description: 'Las cuentas desactivadas no pueden recibir pagos. Puede reactivarlas más tarde.',
    confirm_set_primary: '¿Establecer esta cuenta como principal?',
    confirm_set_primary_description: 'La cuenta principal se usará por defecto para nuevos eventos.',

    // Success messages
    account_created: 'Cuenta Stripe creada con éxito',
    account_updated: 'Cuenta Stripe actualizada con éxito',
    account_synced: 'Estado de la cuenta sincronizado con éxito',
    account_deactivated: 'Cuenta desactivada con éxito',
    primary_account_set: 'Cuenta principal actualizada con éxito',

    // Error messages
    error_creating_account: 'Error al crear la cuenta Stripe',
    error_updating_account: 'Error al actualizar la cuenta Stripe',
    error_syncing_account: 'Error al sincronizar el estado de la cuenta',
    error_deactivating_account: 'Error al desactivar la cuenta',
    error_setting_primary: 'Error al establecer la cuenta principal',
    error_creating_stripe_link: 'Error al crear el enlace de registro de Stripe',
    error_creating_stripe_account: 'Error al crear la cuenta Stripe',

    // Legacy account
    use_legacy_account: 'Usar cuenta personal',
    use_legacy_account_description: 'Usar su cuenta Stripe personal cuando no hay cuenta de organización disponible',
    legacy_account_active: 'Su cuenta Stripe personal está activa y puede ser utilizada',
    legacy_account_pending: 'Su cuenta Stripe personal requiere verificación adicional',
  },

  // Shares distribution (new keys - existing keys like shares_distribution, reservation_details, reservations are in main locale)
  shares_distribution_subheader: 'Resumen de la distribución de ingresos para este evento',
  total_sales: 'Ventas totales',

  // Common
  this_organization: 'esta organización',
};

export default stripeConnectEs;
